/* eslint-disable class-methods-use-this */
import { GpsType } from '../../../../../../../global/components/layout/layout-models';
import { LayDcPlanAdoptionContentModel } from '../../models/plan-adoption-form-models';
import { QccoPlanAdoptionWizard } from '../qcco-plan-adoption-wizard';

export class LayDcPlanAdoptionWizard extends QccoPlanAdoptionWizard {    

    getFormContentModel(): LayDcPlanAdoptionContentModel {

        const institutionSettings = this.epiContent?.institutionSettingsState?.epiContent;
        const content = super.getFormContentModel();

        return {
            ...content,
            pageTitle: institutionSettings?.adoptLayRSVPDetailsTitle,
            PageDescription: institutionSettings?.adoptLayDCDetailsDescription,
            gpsType: GpsType.LayDcAdoptionDetail,
        };
    }    
}